export default {
    'bon_intervention': 'Rapport d\'intervention',
    'facture': 'Facture',
    'devis': 'Devis',
    'photo': 'Photo',
    'autre': 'Autre document',
    'photo_intervention': 'Photo d\'intervention',
    'cerfa': 'CERFA 15497*04',
    'contrat_entretien': 'Contrat d\'entretien',
    'attestation_entretien': 'Attestation d\'entretien',
    'pv_reception': 'PV de réception',
    'rapport_chantier': 'Rapport de chantier',
}